import { render, staticRenderFns } from "./referencias.vue?vue&type=template&id=56786573&scoped=true&"
import script from "./referencias.vue?vue&type=script&lang=js&"
export * from "./referencias.vue?vue&type=script&lang=js&"
import style0 from "./referencias.vue?vue&type=style&index=0&id=56786573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56786573",
  null
  
)

export default component.exports